"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HarmonyConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const MetamaskConnector_1 = require("../../Connectors/Wallets/MetamaskConnector");
const Utils_1 = require("../Utils");
const Factory_1 = require("../../Connectors/Factory");
const WalletConnectConnector_1 = require("../../Connectors/Wallets/WalletConnectConnector");
const CoinbaseConnector_1 = require("../../Connectors/Wallets/CoinbaseConnector");
const TokenPocketConnector_1 = require("../../Connectors/Wallets/TokenPocketConnector");
exports.HarmonyConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.Harmony,
    chainId: Types_1.EthChainIds.Harmony,
    publicRpc: "https://api.harmony.one",
    nativeToken: Tokens_1.ONENativeToken,
    wrappedToken: Tokens_1.ONEWrappedToken,
    upToken: Tokens_1.ONEUpToken,
    unfiToken: Tokens_1.ONEUnfiToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmYm9c8Lx6mSWDvK3qhgnwJmbFEy1on4NXCVbEXHYNMSdt",
    multicall: {
        supported: true,
        address: "0xFE4980f62D708c2A84D3929859Ea226340759320",
        tryAggregate: false,
    },
    connectorFactory: Factory_1.web3ConnectorFactory,
    explorer: {
        baseUrl: "https://explorer.harmony.one/#",
        address: function (address) {
            return `${this.baseUrl}/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/tokens/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/tx/${address}`;
        },
    },
}, [
    MetamaskConnector_1.MetamaskConnector,
    TokenPocketConnector_1.TokenPocketConnector,
    CoinbaseConnector_1.CoinbaseWalletConnector,
    WalletConnectConnector_1.WalletConnectConnector,
], [
    Factory_1.createWeb3OfflineConnectorHelper(Types_1.OfflineConnectors.Harmony, "https://api.harmony.one"),
]);
